import * as v from "valibot";
import { rpcContract } from "../rpc";

const newAttachmentSchema = v.object({
  fileId: v.pipe(v.string(), v.uuid()),
  originalName: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
  sizeBytes: v.pipe(v.number(), v.minValue(1)),
});

const resolvedAttachmentSchema = v.object({
  fileId: v.string(),
  url: v.string(),
  mimeType: v.string(),
  originalName: v.string(),
  sizeBytes: v.number(),
});

export const sendLiveChatMessageRpcContract = rpcContract({
  name: "send-live-chat-message",
  paramsSchema: v.object({
    liveEventId: v.string(),
    content: v.pipe(v.string(), v.maxLength(1000, "Message too long")),
    userName: v.optional(v.string()),
    notifyByEmail: v.optional(v.boolean()),
    attachments: v.optional(v.array(newAttachmentSchema)),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    messageId: v.optional(v.string()),
    sentAt: v.optional(v.string()),
    attachments: v.optional(v.array(resolvedAttachmentSchema)),
  }),
});

export const getLiveChatMessagesRpcContract = rpcContract({
  name: "get-live-chat-messages",
  paramsSchema: v.object({
    liveEventId: v.string(),
    limit: v.optional(v.string()),
    before: v.optional(v.pipe(v.string(), v.uuid())),
  }),
  resultSchema: v.object({
    messages: v.array(
      v.object({
        id: v.string(),
        userId: v.string(),
        userName: v.string(),
        userAvatarUrl: v.nullable(v.string()),
        content: v.string(),
        sentAt: v.string(),
        attachments: v.array(resolvedAttachmentSchema),
      }),
    ),
    hasMore: v.boolean(),
  }),
});

export type SendLiveChatMessageParams = v.InferOutput<typeof sendLiveChatMessageRpcContract.paramsSchema>;
export type SendLiveChatMessageResult = v.InferOutput<typeof sendLiveChatMessageRpcContract.resultSchema>;

export type GetLiveChatMessagesParams = v.InferOutput<typeof getLiveChatMessagesRpcContract.paramsSchema>;
export type GetLiveChatMessagesResult = v.InferOutput<typeof getLiveChatMessagesRpcContract.resultSchema>;

export type LiveChatAttachment = v.InferOutput<typeof resolvedAttachmentSchema>;
